export default __webpack_public_path__ + "static/media/nativeApp.eb6e9945.svg";